import { render } from "./ChipsStock.vue?vue&type=template&id=4fd2d257&scoped=true"
import script from "./ChipsStock.vue?vue&type=script&lang=js"
export * from "./ChipsStock.vue?vue&type=script&lang=js"

import "./ChipsStock.vue?vue&type=style&index=0&id=4fd2d257&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd2d257"]])

export default __exports__